import styled from '@emotion/styled'
import { css } from '@emotion/react'

const baseStyles = ({ theme }) => css`
  label: form__block;

  box-sizing: border-box;
  padding-left: ${theme.spacings.kilo};
  padding-right: ${theme.spacings.kilo};
  width: 100%;
`

const messageStyles = ({ theme }) => css`
  label: form__message;

  color: ${theme.colors.n400};
  font-size: ${theme.typography.subHeadings.kilo.fontSize};
  line-height: ${theme.typography.subHeadings.kilo.lineHeight};
  text-align: left;
  padding-left: ${theme.spacings.mega};
  padding-right: ${theme.spacings.mega};
`

export const Wrapper = styled('div')(baseStyles)
export const Message = styled('p')(messageStyles)
